import { useEffect, useState } from "react";
import { BiSearch } from "react-icons/bi";
import { Link, useHistory } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import "./navbar.css";
import { runningSubscription, dashboardSubscription } from "./../actions/subscription";
import { getAllSubscription } from "./../actions/subscription.js";
import PaymentModal from "../View/Subscription/PaymentModal";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { quickSearchOptions } from "../constant/rooms";
import { frontLabel } from "../Helpers/labels.js";

const mapStateToProps = (state) => ({
  auth: state.auth,
  subscriptions: state.subscription,
  label: state.language,
});

const NavbarSection = ({
  setType,
  isCardView,
  onNavSearch,
  type,
  setSearch1,
  search1,
  propertVal,
  openNav1,
  setOpenNav1,
  auth,
  runningSubscription,
  setPage,
  setRoom,
  ...props
}) => {
  const { frontLabelsName } = props.label;
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [dashboardSubDetails, setDashboardSubDetails] = useState("");
  const [setRunningSub] = useState("");
  const subscriptions = useSelector((state) => state.subscription);
  const subscription_details = subscriptions?.runningSubscription?.message;

  const isAuth = useSelector((state) => state.auth.isAuthenticated);
  const { allSubscription } = subscriptions;
  const subscribed = subscriptions?.runningSubscription?.result?.status === 1;

  useEffect(() => {
    if (isAuth) {
      const userId = localStorage.getItem("user");
      runningSubscription(userId);

    }
  }, []);

  useEffect(() => {
    if (auth?.user?.dayssince == 0) {
      props.getAllSubscription();
    }
  }, [auth?.user?.dayssince]);

  const savePaymentModal = () => {
    setShowPaymentModal(false);
  };

  const [openNav, setOpenNav] = useState(openNav1);
  const history = useHistory();

  const handleNavSearch = () => {
    if (isAuth) {
      setOpenNav(!openNav);
    } else {
      history.push("/sample-properties")
    }
  };

  const quickSearchData = quickSearchOptions(frontLabelsName)

  return (
    <>
      <nav className="navbar navbar-expand navbar-dark bg-dark1">
        <div className="container-fluid customize-navbar p-0">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarTogglerDemo01"
            aria-controls="navbarTogglerDemo01"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
            <ul className="navbar-nav me-auto  mb-lg-0 w-100">

              <li className="nav-li d-flex align-items-center">
                <Link
                  to={
                    isAuth == false
                      ? "/login"

                      : "/dashboard"
                  }
                >
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_dashboard").length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_dashboard")[0][
                      "value"
                      ] || "lbl_dashboard"
                      : "lbl_dashboard"
                    : "lbl_dashboard"}
                </Link>
              </li>
              <li className="nav-li d-flex align-items-center">
                <Link
                  to={
                    isAuth == false
                      ? "/login"
                      : subscription_details == "Your subscription is expired."
                        ? "/sample-properties"
                        : "/properties"
                  }
                >
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_all_properties")
                      .length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_all_properties")[0][
                      "value"
                      ] || "lbl_all_properties"
                      : "lbl_all_properties"
                    : "lbl_all_properties"}
                </Link>
              </li>
              <li className="nav-li d-flex align-items-center">
                <Link
                  to={isAuth === false ? "/login" : "/tenant-list"}
                >
                  {" "}
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_tenant_list").length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_tenant_list")[0][
                      "value"
                      ] || "lbl_tenant_list"
                      : "lbl_tenant_list"
                    : "lbl_tenant_list"}
                </Link>
              </li>

              <li className="nav-li d-flex align-items-center ms-auto">
                {subscribed &&
                  <UncontrolledDropdown
                    nav
                    direction="down"
                    onToggle={handleNavSearch}
                    isOpen={openNav}
                  >
                    <div className='active quick dashboard-quick-search'>
                      <DropdownToggle nav style={{ display: "flex", alignItems: "center", padding: "0px 42px" }}>
                        <>
                          <BiSearch
                            className="nav-search-icon"
                            style={{ color: "#fff !important" }}
                          />
                          <span style={{ color: "#fff", fontSize: "16px" }}>
                            {frontLabel(frontLabelsName, "lbl_quick_search")}
                          </span>
                        </>
                      </DropdownToggle>
                    </div>
                    <DropdownMenu className="dropdown-menu-style" style={{ zIndex: '9000' }}>
                      {quickSearchData.map((data, idx) => {
                        return (
                          <DropdownItem
                            key={idx}
                            onClick={() => { !data.externalLink ? history.push(`/properties/${data.type}/${data.value}`) : window.open(data.externalLink, '_blank').focus() }}
                            className={`d-flex justify-content-between align-items-center dropdown-bottom-border`}
                          >
                            <div className={data.language_code ===
                              localStorage.getItem('i18nextFront') ? "hover-effect-class-active" : "hover-effect-class"}>
                              <span className="d-flex align-items-center logo-position">
                                <label className=" header-dropdown">
                                  {data.label}
                                </label>
                              </span>
                            </div>
                          </DropdownItem>
                        )
                      })}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                }
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div className="payment_modal">
        <PaymentModal
          showModal={showPaymentModal}
          closeModal={savePaymentModal}
          amount={allSubscription?.amount}
          id={allSubscription?._id}
          setDashboardSubDetails={setDashboardSubDetails}
          setRunningSub={setRunningSub}
        />
      </div>
    </>
  );
};

NavbarSection.defaultProps = {
  isCardView: true,
};

export default connect(mapStateToProps, { runningSubscription, dashboardSubscription, getAllSubscription })(NavbarSection);
